import "@/App.css";
import { BrowserRouter, Routes, Route } from "react-router-dom";
import { Layout } from "@/components/layout/Layout";
import Home from "@/pages/Home";
import ServicePage from "@/pages/ServicePage";
import ServiceAreas from "@/pages/ServiceAreas";
import Contact from "@/pages/Contact";
import Legal from "@/pages/Legal";

function App() {
  return (
    <BrowserRouter>
      <Routes>
        <Route element={<Layout />}>
          <Route path="/" element={<Home />} />
          <Route path="/residential/:slug" element={<ServicePage />} />
          <Route path="/commercial/:slug" element={<ServicePage />} />
          <Route path="/service-areas" element={<ServiceAreas />} />
          <Route path="/contact" element={<Contact />} />
          <Route path="/legal" element={<Legal />} />
        </Route>
      </Routes>
    </BrowserRouter>
  );
}

export default App;
